export const baseUrl = 'public/v1/appointment-reminder/client-attendance';

export const ApiAppointment = {
  GetData: (id: string) => `${baseUrl}/${id}`,
  UpdateAppointmentStatus: `${baseUrl}`
};
